import { IBusiness } from '../interfaces/business.interface';
import { Unit } from '../interfaces/unit.interface';

export class BusinessDTO implements IBusiness {
  id!: string;

  name!: string;

  ruc!: string;

  address!: string;

  units!: Omit<Unit, 'order'>[];
}
